// One-shot guard for the landing page's automatic id.utah.gov sign-in.
//
// UtahIdLogin auto-starts the OIDC sign-in once per browser session (so a user
// who lands unauthenticated is sent to id.utah.gov without a click). This flag
// (1) prevents a redirect loop when the user returns still unauthenticated, and
// (2) lets SIGN-OUT suppress the auto sign-in: without suppression, clearing the
// session renders the landing page whose auto sign-in fires a LOGIN redirect
// that races (and hijacks) the sign-out's logout redirect — bouncing the user to
// the id.utah.gov login/profile instead of back to the app origin.
//
// Kept in its own module (not UtahIdLogin) so logout.js can suppress the guard
// WITHOUT importing the React landing component, which would create a circular
// import (FirebaseAuthProvider → logout → UtahIdLogin → FirebaseAuthProvider).
export const AUTO_SIGNIN_ATTEMPTED_KEY = 'uid-pharma:auto-signin-attempted';

const sessionStore = () => {
  try {
    return typeof window !== 'undefined' && window.sessionStorage
      ? window.sessionStorage
      : null;
  } catch {
    return null;
  }
};

/** True when the one-shot auto sign-in has already been attempted this session. */
export const wasAutoSigninAttempted = () => {
  try {
    return sessionStore()?.getItem(AUTO_SIGNIN_ATTEMPTED_KEY) === 'true';
  } catch {
    return false;
  }
};

/**
 * Mark the one-shot auto sign-in as attempted. Called by the landing page after
 * it auto-starts sign-in, and by SIGN-OUT to SUPPRESS the auto sign-in so the
 * landing page cannot fire a login redirect that races the logout.
 */
export const markAutoSigninAttempted = () => {
  try {
    sessionStore()?.setItem(AUTO_SIGNIN_ATTEMPTED_KEY, 'true');
  } catch {
    /* storage unavailable — auto sign-in simply falls back to the manual button */
  }
};
